(function () {
  'use strict';

  if (window.PGCompleteSetThirtyV1) return;
  window.PGCompleteSetThirtyV1 = true;

  function updateCopy(root) {
    (root || document).querySelectorAll('.pg-complete-set__badge').forEach(function (node) {
      node.textContent = '30% off';
    });

    (root || document).querySelectorAll('.pg-complete-set__intro').forEach(function (node) {
      node.textContent = 'Save 30% on matching extras. No second photo upload needed.';
    });

    (root || document).querySelectorAll('.pg-complete-set__discount-status').forEach(function (node) {
      node.textContent = '30% discount applied automatically in your cart.';
    });
  }

  function init() {
    updateCopy(document);

    if (window.MutationObserver) {
      var observer = new MutationObserver(function (mutations) {
        mutations.forEach(function (mutation) {
          mutation.addedNodes.forEach(function (node) {
            if (!(node instanceof Element)) return;
            if (node.matches('[data-pg-complete-set], [data-pg-complete-set-mount]') || node.querySelector('[data-pg-complete-set]')) {
              updateCopy(node);
            }
          });
        });
      });
      observer.observe(document.body, { childList: true, subtree: true });
    }

    document.addEventListener('cart:refresh', function () {
      window.setTimeout(function () { updateCopy(document); }, 80);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
